import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import { SearchContext } from '../Contexts';

const ClearButton = ({ label }) => {
  const {
    facetsLists,
    setFacetsLists,
    selectedFacets,
    setDateRange,
    dropdownValue,
    setQuery,
    setSelectedFacets
  } = useContext(SearchContext);

  const handleRemoveAll = () => {
    const facetsClone = [...facetsLists];
    // set all facets to false
    facetsClone.forEach(list => {
      // clean selectedFacet params for api call
      selectedFacets[list.mainValue] = [];
      list.facets.forEach(facet => {
        facet.selected = false;
        // clean all childrens if exists
        if (facet.childrens && facet.childrens.length) {
          facet.childrens.forEach(c => {
            c.selected = false;
          });
        }
      });
    });

    setSelectedFacets([]);

    setQuery('');

    setFacetsLists(facetsClone);

    setDateRange([
      { label: 'From', value: '', placeholder: 'Year' },
      { label: 'To', value: '', placeholder: 'Year' }
    ]);

    dropdownValue.forEach((_, i) => {
      dropdownValue[i] = 'Year';
    });
  };
  return (
    <div>
      <button
        className="advanced-search__reset-button"
        type="button"
        onClick={() => handleRemoveAll()}
      >
        {label}
      </button>
    </div>
  );
};

ClearButton.propTypes = {
  label: PropTypes.string
};

export default ClearButton;
